import { buildLoader } from '../util/GenericLoader';
import fetchAllEquipTypesActionCreator from '../../redux/actions/equiptypes';

export default buildLoader(fetchAllEquipTypesActionCreator);
